export interface LocalizedTimezone {
  value: string;
  shortName: string;
  longName: string;
  offset: string;
}

const cache = new Map<string, LocalizedTimezone[]>();

const buildOne = (iana: string, locale: string, ref: Date): LocalizedTimezone => {
  const long = new Intl.DateTimeFormat(locale, { timeZone: iana, timeZoneName: "long" })
    .formatToParts(ref).find(p => p.type === "timeZoneName")?.value ?? iana;
  const short = new Intl.DateTimeFormat(locale, { timeZone: iana, timeZoneName: "short" })
    .formatToParts(ref).find(p => p.type === "timeZoneName")?.value ?? iana;
  const offsetRaw = new Intl.DateTimeFormat(locale, { timeZone: iana, timeZoneName: "longOffset" })
    .formatToParts(ref).find(p => p.type === "timeZoneName")?.value ?? "";
  return { value: iana, shortName: short, longName: long, offset: offsetRaw.replace("GMT", "UTC") };
};

export const getAllTimeZones = (locale: string): LocalizedTimezone[] => {
  const cached = cache.get(locale);
  if (cached) return cached;
  const ref = new Date();
  const list = Intl.supportedValuesOf("timeZone")
    .map(iana => buildOne(iana, locale, ref))
    .sort((a, b) => a.value.localeCompare(b.value));
  cache.set(locale, list);
  return list;
};

export const getTimeZoneFromIana = (iana: string, locale: string): LocalizedTimezone => {
  const hit = getAllTimeZones(locale).find(tz => tz.value === iana);
  if (hit) return hit;
  return buildOne(iana, locale, new Date());
};

export const formatTimeZone = (tz: LocalizedTimezone) => `(${tz.offset}) ${tz.longName}`;

